import { format } from "date-fns";

export interface Property {
  id: string;
  label: string;
  type:'number' | 'text' | 'boolean' | 'datetime-local' | 'time'|'date';
  required?: boolean;
  disabled?: boolean;
  default?: any;
  format?: (value: string|number) => string;
}

export interface ModelProperty {
  [model:string]:Property[]
}

export const modelProperties:ModelProperty = {
  'agendamentospresenciais': [
    { id: 'dataHoraSessao', label: 'Data e hora' , type: 'datetime-local', format: (value:string|number) => format(new Date(value),"dd/MM/yyyy HH'h'")},
    { id: 'sessaoEscolhidaId', label: 'Id da sessão escolhida', type: 'number'},
    { id: 'instituicao', label: 'Instituição', type: 'text'},
    { id: 'serie', label: 'Série/Ano' , type: 'text'},
    { id: 'alunos', label: 'Nº de participantes' , type: 'number'},
    { id: 'alunosPresentes', label: 'Nº de participantes presentes' , type: 'number'},
    { id: 'professor', label: 'Professor(a)' , type: 'text'},
    { id: 'nome', label: 'Nome', type: 'text'},
    { id: 'email', label: 'Email', type: 'text'},
    { id: 'telefone', label: 'Telefone', type: 'text'},
    { id: 'municipio', label: ' Município', type: 'text'},
    { id: 'emailProfessor', label: 'Email do professor', type: 'text'},
    { id: 'telefoneProfessor', label: 'Telefone do professor', type: 'text'},
    { id: 'tipoEscola', label: 'Tipo da escola', type: 'text'},
    { id: 'telefoneEscola', label: 'Telefone da escola', type: 'text'},
    { id: 'alunoDeficiente', label: 'Aluno deficiente?', type: 'text'},
    {id: 'virtual', label: 'Virtual', type: 'boolean',disabled: true, default:false},
  ],
  'agendamentosvirtuais': [
    { id: 'dataHoraSessao', label: 'Data e hora' , type: 'datetime-local', format: (value:string|number) => format(new Date(value),"dd/MM/yyyy HH'h'")},
    { id: 'sessaoEscolhidaId', label: 'Id da sessão escolhida', type: 'number'},
    { id: 'instituicao', label: 'Instituição', type: 'text'},
    { id: 'serie', label: 'Série/Ano' , type: 'text'},
    { id: 'alunos', label: 'Nº de participantes' , type: 'number'},
    { id: 'alunosPresentes', label: 'Nº de participantes presentes' , type: 'number'},
    { id: 'professor', label: 'Professor(a)' , type: 'text'},
    { id: 'nome', label: 'Nome', type: 'text'},
    { id: 'email', label: 'Email', type: 'text'},
    { id: 'telefone', label: 'Telefone', type: 'text'},
    { id: 'municipio', label: ' Município', type: 'text'},
    { id: 'emailProfessor', label: 'Email do professor', type: 'text'},
    { id: 'telefoneProfessor', label: 'Telefone do professor', type: 'text'},
    { id: 'tipoEscola', label: 'Tipo da escola', type: 'text'},
    { id: 'telefoneEscola', label: 'Telefone da escola', type: 'text'},
    { id: 'alunoDeficiente', label: 'Aluno deficiente?', type: 'text'},
    {id: 'virtual', label: 'Virtual', type: 'boolean',disabled: true, default:true},
  ],
  'user': [
    {id: 'email', label: 'Email', type: 'text'}
  ],
  'sessoesvirtuais': [
    {id: 'titulo', label: 'Título', type: 'text', required: true},
    {id: 'sinopse', label: 'Sinopse', type: 'text', required: true},
    {id: 'tópicos', label: 'Tópicos', type: 'text', required: true},
    {id: 'recomendação', label: 'Recomendação', type: 'text',required: true},
    {id: 'virtual', label: 'Virtual', type: 'boolean',disabled: true, default:true},
  ],
  'sessoespresenciais': [
    {id: 'titulo', label: 'Título', type: 'text', required: true},
    {id: 'sinopse', label: 'Sinopse', type: 'text', required: true},
    {id: 'tópicos', label: 'Tópicos', type: 'text', required: true},
    {id: 'recomendação', label: 'Recomendação', type: 'text',required: true},
    {id: 'virtual', label: 'Virtual', type: 'boolean',disabled: true, default:false},
  ],
  'horariosdisponiveisvirtuais':[
    { id: 'horario', label: 'Horário' , type: 'time'},
    { id: 'virtual', label: 'Virtual', type: 'boolean',disabled: true, default:true},
  ],
  'horariosdisponiveispresenciais':[
    { id: 'horario', label: 'Horário' , type: 'time'},
    { id: 'virtual', label: 'Virtual', type: 'boolean',disabled: true, default:false},
  ],
  'avaliacoes':[
    { id: 'avaliadoEm', label: 'Avaliado em', type: 'datetime-local', format: (value:string|number) => format(new Date(value),"dd/MM/yyyy HH'h'")},
    { id: 'crítica', label: 'Crítica', type:'text'},
    { id: 'nota', label: 'Nota', type:'number'},
  ],
  'horariosindisponiveisvirtuais':[
    { id: 'dataHorario', label: 'Horário' , type: 'datetime-local'},
    { id: 'virtual', label: 'Virtual', type: 'boolean',disabled: true, default:true},
  ],
  'horariosindisponiveispresenciais':[
    { id: 'dataHorario', label: 'Data e Horário' , type: 'datetime-local'},
    { id: 'virtual', label: 'Virtual', type: 'boolean',disabled: true, default:false},
  ],
  'periodosindisponiveisvirtuais':[
    { id: 'diaInicial', label:'Dia Inicial', type:'date'},
    { id: 'diaFinal', label:'Dia Final', type:'date'},
    { id: 'virtual', label: 'Virtual', type: 'boolean',disabled: true, default:true},
  ],
  'periodosindisponiveispresenciais':[
    { id: 'diaInicial', label:'Dia Inicial', type:'date'},
    { id: 'diaFinal', label:'Dia Final', type:'date'},
    { id: 'virtual', label: 'Virtual', type: 'boolean',disabled: true, default:false},
  ]
}
